var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',[_c('Overlay'),_c('Parceiros'),_c('Cards'),_c('Quem-somos'),_c('Obras'),_c('POPUPS'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }